export default "__VITE_ASSET__Cw7AYbe0__"